import useSWR from "swr";

const fetcher = async (src: string): Promise<Boolean> => {
  const res = await fetch(src, { method: "HEAD" });
  return res.ok;
};

export function useCheckFileExists(src: string) {
  const { data: responseOk, error, isLoading } = useSWR<Boolean>(src, fetcher);

  return {
    doesExist: responseOk,
    isLoading,
    error,
  };
}
